class EventsTracking {
  constructor() {

    this.forms = document.querySelectorAll('.gform_wrapper')
    this.events()
  }

  // Events
  events() {
    this.forms.forEach(form => {
      form.querySelector('input[type="submit"]')?.
        addEventListener('click', this.yaMetrics.bind(this))
    })
  }

  // Methods
  yaMetrics(event) {
    const eventEl = event.target.closest('.gform_wrapper').
      querySelector('.ax-event-name input')
    const eventPrice = event.target.closest('.gform_wrapper').
      querySelector('.ax-event-price input')

    const goalParams = {
      order_price: eventPrice ? Math.round(eventPrice.value) : 0,
      currency: 'RUB',
    }
    if (eventEl) {
      yaCounter37008360.reachGoal(eventEl.value, goalParams)
      return true
    }
  }
}

export default EventsTracking
